import {
  //   ApiGetRequest,
  ApiPostRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
// import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Laporan Laba Rugi 12 Bulan',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Laporan Laba Rugi 12 Bulan',
        href: '/adm/fin/laporan/laba-rugi-setahun',
        active: true,
      },
    ],
    form: {
      periode: '',
    },
    report: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeLabaRugiSetahun(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getLabaRugiSetahun({ commit, state }) {
    commit('changeLabaRugiSetahun', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(
      `fin/laporan/laba-rugi-setahun`,
      data.form
    );
    commit('changeLabaRugiSetahun', {
      report: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },
};
